import axios from 'axios';
import {backendHost} from '../../config';

export const getProfile = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/profile`, {params});
};